<template>
  <div  ref="navbar" class="nexum-nav-bar">
    <b-navbar class="main-header" :class="{container: wMD|| wLG || wXL}">
      <b-navbar-brand>
        <router-link :to="{ name: 'user-dashboard', params: { id: user.name }}">
          <img src="../../assets/nexum_logo.png" alt="Nexum finanzas">
        </router-link>
      </b-navbar-brand>
      <b-navbar-nav class="d-flex flex-row">
        <b-nav-item class="user-header-box">
          <span>{{user.name}}</span>
        </b-nav-item>
        <b-nav-item class="d-none d-md-block">
          <b-button :size="'sm'" :variant="'primary'" v-on:click="doLogout()">
            <span><i class="fa fa-sign-out"></i></span>
          </b-button>
        </b-nav-item>
        <b-nav-item class="d-block d-md-none d-flex flex-row">
          <b-button-toolbar>
            <b-button-group>
              <b-button :size="'sm'" :variant="'primary'"
                        @click="toggleMenu = !toggleMenu"
                        :class="showMenu ? 'collapsed' : null"
                        aria-controls="collapse1"
                        :aria-expanded="showMenu ? 'true' : 'false'">
                <span><i class="fa fa-bars" aria-hidden="true"></i></span>
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <div class="collapse-menu">
      <b-collapse id="collapse1" v-model="showMenu">
        <div class="user-subheader">
          <div class="container">
            <b-navbar toggleable="md" >
              <b-nav-item class="d-block d-md-none salir">
                <b-btn :size="'sm'" :variant="'primary'" v-on:click="doLogout()">
                  <span><i class="fa fa-sign-out"></i></span>
                </b-btn>
              </b-nav-item>
              <b-navbar-nav>
                <b-nav-item :to="{ name: 'buscar-operacion' }">Operaciones</b-nav-item>
                <b-nav-item :to="{ name: 'buscar-cesion' }">Cesiones</b-nav-item>
                <b-nav-item :to="{ name: 'buscar-cliente' }">Clientes</b-nav-item>
                <b-nav-item-dropdown text="Inversiones" >
                  <b-dropdown-item :to="{ name: 'buscar-inversor' }">Inversores</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'menu-ficha-comercial' }">Fichas Inversiones</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'menu-ficha-inmobiliaria' }">Fichas Inmobiliarias</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item :to="{ name: 'colaboradores' }" >Colaboradores</b-nav-item>
                <b-nav-item :to="{ name: 'admin' }">Administración</b-nav-item>
              </b-navbar-nav>
            </b-navbar>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<style lang="scss">
  @import "../../theme/nexum-bootstrap";
  @import "../../../node_modules/bootstrap/scss/bootstrap";
  .dropdown-menu.dropdown-menu-left.show {
    background: $linear-orange;
  }
  .dropdown .dropdown-menu .dropdown-item.active {
    background: $linear-orange;
  }
  .dropdown .dropdown-menu .dropdown-item:focus {
    background: $linear-orange;
    outline-color: white;
  }
  .nexum-nav-bar {
    z-index: 5;
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    .main-header {
      padding-top: 0;
      padding-bottom: 0;
      @include media-breakpoint-down(sm) {
        padding: 0 1vw 0 0;
      }
      .navbar-brand {
        img {
          width: 12rem;
          @include media-breakpoint-down(lg) {
            width: 10rem;
          }
          @include media-breakpoint-down(md) {
            width: 9rem;
          }
          @include media-breakpoint-down(sm) {
            width: 6rem;
          }
          @include media-breakpoint-down(xs) {
            width: 6rem;
          }
        }
      }
      .navbar-nav {
        .nav-item {
          align-self: center;
        }
        .user-header-box {
          margin-right: 1vw;
        }
        img {
          width: 3rem;
          @include media-breakpoint-down(lg) {
            width: 3rem;
          }
          @include media-breakpoint-down(sm) {
            width: 2rem;
          }
        }
        .btn-group {
          .btn-primary {
            background-color: white;
          }
        }
      }
    }
    .collapse-menu {
      border-top: 1px solid transparent;
      padding-top: 1px;
      background-image: $linear-orange;
      #collapse1 {
        .user-subheader {
          min-height: 50px;
          background-image: $linear-orange;
          .container {
            .navbar {
              .salir {
                position: absolute;
                right: 0;
                bottom: 0;
                margin-right: -16px;
              }
              .navbar-nav {
                text-align: left;
                .nav-item {
                  a {
                    color: white;
                  }
                }
              }
            }
          }
          @include media-breakpoint-up(md) {
            .container {
              .navbar-nav {
                flex-direction: row;
                .nav-item {
                  margin: 0 10px;
                }
              }
            }
          }
        }

      }
    }
  }
</style>
<script>
  import { mapGetters } from 'vuex';
  import MediaQueryMixin from '../../mixin/mediaquery.mixin';

  export default {
    name: 'nexum-nav-bar',
    mixins: [MediaQueryMixin],
    props: ['isScrolling'],
    data() {
      return {
        toggleMenu: false,
        actualScroll: 0,
        initialScroll: 0,
        scrolling: false,
      };
    },
    computed: {
      showMenu: {
        get() {
          return this.toggleMenu || (!this.wXS && !this.wSM);
        },
        set(value) {
          return value;
        },
      },
      ...mapGetters({
        user: 'user',
        layout: 'layout',
      }),
    },
    methods: {
      doLogout() {
        this.$store.dispatch('logoutAction');
      },

      handleScroll() {
        this.actualScroll = this.layout.scrollY;
        if (this.actualScroll < 200) {
          return;
        }
        if (this.actualScroll > (this.initialScroll)) {
          this.scrolling = true;
        } else if (this.actualScroll < (this.initialScroll + 100)) {
          this.scrolling = false;
        }
        this.initialScroll = this.actualScroll;
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
      this.nav = this.$refs.navbar;
      window.addEventListener('scroll', this.handleScroll);
    },
  };
</script>



// WEBPACK FOOTER //
// src/features/user/UserNavBar.component.vue